import React from 'react';
import { Icon } from './Icon.js';
export const IconBatteryFull = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M21 6L2 6L2 18L21 18L21 15L23 15L23 9L21 9L21 6Z", stroke: "currentColor", strokeWidth: "2", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M17 10L6 10L6 14L17 14L17 10Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconBatteryFull.js.map